import styled from 'styled-components';

const Empty = styled.div`
  padding: ${(props) => props.theme.notifications.padding.main};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export { Empty };
